import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{attrs:{"justify":"center"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('title_HallOfFameFutures')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }